<div class="row flex-md-nowrap gy-3 h-100">
  <div class="col h-100">
    <div class="p-3 bg-white border d-flex flex-column mh-100 overflow-hidden rounded-4 shadow-sm">
      @if (hasExecutedRule()) {
        @for (tag of executedRuleTags(); track tag.executionId) {
          <span class="badge bg-info-subtle text-info fw-500 mb-3 align-self-start">
            <i class="bi bi-arrow-repeat"></i>
            Floor plan rule executed - {{ tag.label }}
          </span>
        }
      }
      <div class="d-flex align-items-center mb-3 flex-wrap gap-2">
        @if (!isDealOptionsLoading() && dealsOptions().length > 0 && canWriteDeals()) {
          <input
            #selectAllPrint
            type="checkbox"
            class="form-check-input m-0"
            [checked]="isAllAddendumsSelectedForPrint()"
            (change)="onSelectAllPrintChange($event)"
            (click)="$event.stopPropagation()"
            aria-label="Select all addendums for printing"
          />
        }
        <h2 class="mb-0">Addendums</h2>
        <div class="d-flex align-items-center gap-2 ms-auto flex-wrap">
          @if (canWriteDeals()) {
            @if (effectiveTargetDate()) {
              <button
                class="btn btn-outline-primary btn-h42"
                type="button"
                [disabled]="isDealOptionsLoading() || dealsOptions().length === 0"
                (click)="printAddendums()"
              >
                <i class="bi bi-printer fs-20"></i>
                {{ printAddendumsButtonLabel() }}
              </button>
            } @else {
              <button
                class="btn btn-h42 disabled"
                style="pointer-events: all"
                type="button"
                ngbTooltip="Target date is not set"
                triggers="mouseenter:mouseleave"
              >
                <i class="bi bi-printer fs-20"></i> Print Addendums
              </button>
            }
          }
          @if (canWriteDeals() && !isDealCancelled()) {
            <button class="btn btn-primary btn-h42" type="button" (click)="openAddOptionModal()">
              <i class="bi bi-file-earmark-plus fs-20"></i>
              Add Addendums
            </button>
          }
        </div>
      </div>
      <div class="accordion-treeview overflow-y-auto mh-100 flex-fill pe-3 me-n3 d-flex flex-column gap-3">
        <div class="d-flex flex-column gap-3">
          @if (isDealOptionsLoading()) {
            <lib-skeleton [count]="3" [lines]="2" cardClass="rounded-4" />
          } @else {
            @for (dealAddendum of dealsOptions(); track dealAddendum.id; let i = $index) {
              <div
                (click)="onAddendumSelect(dealAddendum.id)"
                class="border rounded-4 overflow-hidden p-3 cursor-pointer position-relative card-header-addendum"
                [class.selected-addendum]="
                  dealAddendum.id === selectedAddendumId() && this.selectedProductId() === null
                "
                [class.addendum-expanded]="dealAddendum.isExpanded"
              >
                <div class="d-flex align-items-center gap-2">
                  <div class="d-flex gap-2 flex-xl1-row flex-fill">
                    <input
                      type="checkbox"
                      class="form-check-input flex-shrink-0 align-self-baseline"
                      [checked]="isAddendumSelectedForPrint(dealAddendum.id)"
                      (change)="onAddendumPrintToggle(dealAddendum.id, $event)"
                      (click)="$event.stopPropagation()"
                      [attr.aria-label]="'Select addendum ' + dealAddendum.seq + ' for printing'"
                    />
                    <div class="flex-fill">
                      <deal-addendum-preview
                        (click)="$event.stopPropagation(); onAddendumSelect(dealAddendum.id)"
                        class="w-100 d-flex align-items-center"
                        [dealAddendum]="dealAddendum"
                        (onChanges)="onOptionChanges()"
                      ></deal-addendum-preview>
                    </div>
                  </div>
                  <span class="d-flex gap-2 align-items-center">
                    <span
                      class="bg-info-subtle arrow-addendum wh-28 d-inline-flex rounded-2 d-flex-center"
                      type="button"
                      (click)="$event.stopPropagation(); dealAddendum.isExpanded = !dealAddendum.isExpanded"
                    >
                      @if (dealAddendum.isExpanded) {
                        <i class="bi bi-chevron-down fs-18 lh-1"></i>
                      } @else {
                        <i class="bi bi-chevron-right fs-18 lh-1"></i>
                      }
                    </span>
                  </span>
                </div>
                @if (dealAddendum.isExpanded) {
                  <div class="d-block">
                    <deal-addendum-options
                      [selectedProductId]="selectedProductId()"
                      [dealAddendum]="dealAddendum"
                      [dealCancelled]="isDealCancelled()"
                      [modelId]="effectiveModelId()"
                      [elevationId]="effectiveElevationId()"
                      (onChanges)="onOptionChanges()"
                      (onProductSelected)="onAddendumProductSelect(dealAddendum.id, $event)"
                      (onKitProductSelected)="onAddendumProductSelect(dealAddendum.id, $event, true)"
                    ></deal-addendum-options>
                  </div>
                }
                @if (dealAddendum.createdByUserFullName) {
                  <div class="text-end mt-2">
                    <span class="fs-12 text-muted">
                      Created By <span class="fw-600">{{ dealAddendum.createdByUserFullName }}</span> on
                      <span class="fw-600">{{ dealAddendum.createdAt | date: 'MM/dd/yyyy' }}</span>
                    </span>
                  </div>
                }
              </div>
            }
          }
        </div>
      </div>
    </div>
  </div>

  @if (showAddendumDetails() || showOptionDetails()) {
    <div class="col-md-5 col-xl1-3 h-100">
      @if (showAddendumDetails()) {
        <deal-addendum-details
          [dealAddendum]="selectedAddendum()!"
          [dealCancelled]="isDealCancelled()"
          [isUnderContract]="isUnderContract()"
          (onChanges)="onOptionChanges()"
        ></deal-addendum-details>
      }
      @if (showOptionDetails()) {
        <deal-addendum-option-details
          [dealAddendum]="selectedAddendum()!"
          [addendumProductId]="selectedProductId()!"
          (onChanges)="onOptionChanges()"
          [isKitLinkedProduct]="selectedKitProductId === selectedProductId()"
        ></deal-addendum-option-details>
      }
    </div>
  }
</div>

<ng-template #roomReplacementDisclosureModal>
  @if (currentDisclosure(); as execution) {
    <div class="p-4 d-flex flex-column">
      <h5 class="fw-bold mb-3">Floor plan rule executed</h5>
      <i class="bi bi-exclamation-triangle text-warning align-self-center" style="font-size: 2.5rem"></i>
      <p class="mt-3 mb-4">
        <strong>{{ currentDisclosureLabel() }}</strong>
        room replacement rule was executed, replacing
        <strong>{{ roomNames(execution.replacedRooms) }}</strong>
        with
        <strong>{{ roomNames(execution.newRooms) }}</strong
        >.
      </p>
      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-primary btn-h42" (click)="acknowledgeCurrentDisclosure()">
          Acknowledge
        </button>
      </div>
    </div>
  }
</ng-template>
